import { LOCAL_PICKUP_FIELD_NAMES } from "@self/utils";
import { bound } from "../CustomElement";
import { BillingCheckbox } from "./BillingAddressCheckbox";

export class DeliveryOptionPicker extends HTMLElement {
	previousBillingCheckbox: boolean | null;
	deliveryOption: HTMLInputElement;
	pickupOption: HTMLInputElement;

	constructor() {
		super();

		this.previousBillingCheckbox = null;
		this.deliveryOption = document.getElementById("delivery-option") as HTMLInputElement;
		this.pickupOption = document.getElementById("pickup-option") as HTMLInputElement;
	}

	connectedCallback() {
		this.deliveryOption.addEventListener("change", this.onChange);
		this.pickupOption.addEventListener("change", this.onChange);
	}

	disconnectedCallback() {
		this.deliveryOption.removeEventListener("change", this.onChange);
		this.pickupOption.removeEventListener("change", this.onChange);
	}

	@bound
	onChange(event: Event) {
		const shippingOption = (event.currentTarget as HTMLElement).id;

		const deliveryQuestion = document.getElementById("delivery-question")!;
		const shopInfo = document.getElementById("shop-location")!;

		const checkoutDeliveryElement = document.getElementById("checkout-delivery") as HTMLElement;
		const deliveryInputs = checkoutDeliveryElement.querySelectorAll("select, input") as NodeListOf<HTMLInputElement | HTMLSelectElement>;

		const billingCheckbox = document.querySelector<BillingCheckbox>("gct-billing-address-checkbox");

		if (shippingOption === "pickup-option") {

			for (const input of deliveryInputs) {
				if (input.type === "hidden") continue;

				const container = input.parentNode as HTMLElement;
				container.classList[LOCAL_PICKUP_FIELD_NAMES.includes(input.name) ? "remove" : "add"]("gct-d-none");
			}

			if (billingCheckbox !== null) {
				this.previousBillingCheckbox = billingCheckbox?.checked;
				billingCheckbox.disabled = true;
				billingCheckbox.checked = false;
			}

			deliveryQuestion.innerText = "Who will be picking up your order?";
			shopInfo.classList.remove("gct-d-none");
		} else if (shippingOption === "delivery-option") {

			for (const input of deliveryInputs) {
				if (input.type === "hidden") continue;

				const container = input.parentNode as HTMLElement;
				container.classList.remove("gct-d-none");
			}

			if (billingCheckbox !== null) {
				billingCheckbox.disabled = false;
				billingCheckbox.checked = this.previousBillingCheckbox ?? true;
				this.previousBillingCheckbox = null;
			}

			deliveryQuestion.innerText = "Where should we send your order?";
			shopInfo.classList.add("gct-d-none");
		}
	}
}
